import { useState } from 'react';
import { IUpdateModelResultDownload } from 'types';
import useVariable from './useVariable';

const useUpdateModelResultDownload = () => {
  const [outputAssemblyUrl, setOutputAssemblyUrl] = useState('');
  const [resultFileNameRef, setResultFileNameRef] = useVariable('');
  const [resultFileJobId, setResultFileJobId] = useVariable('');

  const handleUpdateModelResultDownload = (data: IUpdateModelResultDownload, allowResultDownload: boolean) => {
    if (!allowResultDownload || !data.jobId) return;

    setOutputAssemblyUrl(data.results.outputAssembly.url);
    setResultFileJobId(data.jobId);
    setResultFileNameRef(data.results.resultFileName);
  };

  return [
    handleUpdateModelResultDownload,
    {
      outputAssemblyUrl,
      resultFileNameRef,
      resultFileJobId,
    },
  ] as const;
};

export { useUpdateModelResultDownload };
